import { useModal } from "../core/Root/modal-root"
import { DialogDiagnoseIssue } from "./diagnoseIssueModal"

export function useDiagnoseIssueModal() {
  const { showModal } = useModal()

  const handleDiagnoseIssue = () => {
    showModal(() => <DialogDiagnoseIssue />)
  }

  return { handleDiagnoseIssue }
}
